export default __webpack_public_path__ + "static/media/param_nav_icon.d4d7f494.svg";